// @Initial state
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_options: [],
  completed: false,
};

// @Slice
export const workflow = createSlice({
  name: "workflow",
  initialState,
  reducers: {
    setCurrentOption: (state, { payload }) => {
      state.current_options = payload;
    },
    setWorkflowComplete: (state, { payload }) => {
      state.completed = payload;
    },
  },
});

export default workflow.reducer;

export const { setCurrentOption, setWorkflowComplete } = workflow.actions;
